import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Header from './components/Header';
import Home from './pages/Home';
import Login from './pages/Login';
import RoadtripList from './pages/RoadtripList';
import RoadtripDetail from './pages/RoadtripDetail';
import NewRoadtrip from './pages/NewRoadtrip';

// Composant pour les routes protégées
const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  const shareToken = new URLSearchParams(window.location.search).get('token');

  // Si l'utilisateur est connecté ou s'il y a un share_token, on permet l'accès
  return user || shareToken ? children : <Navigate to="/login" />;
};

function App() {
  const { user } = useAuth();

  return (
    <Router>
      <div className="App">
        <Header />
        <main className="container mt-4">
          <Routes>
            <Route path="/login" element={
              user ? <Navigate to="/" /> : <Login />
            } />
            <Route path="/" element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            } />
            <Route path="/roadtrips" element={
              <PrivateRoute>
                <RoadtripList />
              </PrivateRoute>
            } />
            <Route path="/roadtrip/:id" element={
              <PrivateRoute>
                <RoadtripDetail />
              </PrivateRoute>
            } />
            <Route path="/new-roadtrip" element={
              <PrivateRoute>
                <NewRoadtrip />
              </PrivateRoute>
            } />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App; 